<template>
  <div id="SkeletonScreen">
    <div class="header">
      <div class="container">
        <!-- <div class="header-top">
          <button class="close"></button>
        </div> -->
        <div class="logo"></div>
        <div class="franchisee-name"></div>
        <div class="product-name"></div>
        <div class="price-box">
          <div class="price"></div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="container">
        <div class="text">
          <div class="body-title"></div>
          <!-- <div class="sub-title-full"></div>
          <div class="sub-title-article"></div> -->
        </div>

        <!-- <div class="selector-list">
          <div v-for="(item, idx) in [,,,]" :key="idx" class="selector-item">
            <span class="check-item"></span>
          </div>
        </div> -->

        <div class="input-box">
          <div class="input-row">
            <div class="row-title"></div>
            <div class="row-content"></div>
          </div>
          <div class="input-row">
            <div class="row-title"></div>
            <div class="row-content"></div>
          </div>
        </div>

      </div>
    </div>
    <div class="footer">
      <div class="footer-button"></div>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
  data() {
    return {
    }
  },
  created() {
    this.setTheme();
    this.fetchPaymentInformation();
  },
  methods: {
    ...vuex.mapActions({
      'setColor': 'style/setColor',
      'FETCH_PAYMENT_INFORMATION': 'FETCH_PAYMENT_INFORMATION',
      'SET_ERROR_PAGE': 'SET_ERROR_PAGE'
    }),
    async setTheme () {
      await this.setColor({
        primaryColor: '#1D9BF7',
        primaryColorDark: '#146BAB',
        secondaryColor: '#48A9EF',
      })
    },
    async fetchPaymentInformation() {
      let query = this.$route.query;
      if(query.api_key && query.order_no && query.token) {
        let res = await this.FETCH_PAYMENT_INFORMATION(query)

        if(res.data && res.data.success === false ) {
          this.SET_ERROR_PAGE({
            message: res.data.resp_message,
            code: res.data.resp_code
          })
          this.$router.push('/page/failure')

          return;
        }


        this.$i18n.locale = res.data.payload.language;

        if(res.status !== 200 || res.data.error_code) {
          console.log('Error!!');
          return 0;
        }

        let resultStatus = res.data.status;
        if(resultStatus !== 'request') {
          let errorObject = {
            message: '',
            code: ''
          }
          switch(resultStatus) {
            case 'error':
              errorObject.message = '에러!';
              errorObject.code = '0000';
              break;
            case 'pending':
              errorObject.message = '결제 대기중 입니다!';
              errorObject.code = '2222';
              break;
            case 'success':
              errorObject.message = '이미 결제한 주문입니다!';
              errorObject.code = '1111';
              break;
          }
          this.SET_ERROR_PAGE(errorObject)
          this.$router.push('/page/failure')
        }

        if(res.data.pg_kind === "pg_s") {
          this.$router.push(`/payment/certification`)
        }

        setTimeout(()=>{
          if(this.$route.name === 'Skeleton') {
            this.routePaymentPage(res.data);
          }
        }, 500)
      } else {
        this.$router.push('/notfound')
      }
    },
    routePaymentPage(data) {
      let methodType = data.pay_method;

      if(methodType === 'local') {
        this.$router.push(`/payment/domestic`)
      } else if(methodType === 'overseas') {
        this.$router.push(`/payment/global`)
      }
    }
  }
}
</script>

<style lang="scss">
$base-color: #ddd;
$shine-color: #e8e8e8;
$achromatic-1: #f2f2f2;
$achromatic-2: #e0e0e0;
$achromatic-3: #bdbdbd;
$achromatic-4: #b3b3b3;
$achromatic-5: #999;
$achromatic-6: #888;
$achromatic-7: #424242;
$achromatic-8: #1a1a1a;
$achromatic-9: #d8d8d8;
$animation-duration: 1.6s;
// $animation-duration: 2s;
$avatar-offset: 52 + 16;

@mixin background-gradient-1 {
  background-image: linear-gradient(90deg, $achromatic-1 0px, $achromatic-2 40px, $achromatic-1 80px);
  background-size: 600px;
}

@mixin background-gradient-2 {
  background-image: linear-gradient(90deg, $achromatic-9 0px, $achromatic-1 40px, $achromatic-9 80px);
  background-size: 800px;
}

#SkeletonScreen {
  .header {
    padding: 28px 30px 21px;

    background-color: #d8d8d8;

    .container {
      @include basic-display;
    }

    .header-top {
      overflow: hidden;
      height: 44px;

      .close {
        position: absolute;
        right: 0;
        width: 44px;
        height: 44px;

        background-color: inherit;
        background-image: url('../../images/close-nor.svg');
        background-position: center;
        background-size: 44px;
        background-repeat: no-repeat;
      }
    }

    .logo {
      width: 114px;
      height: 28px;
      margin: 0 auto;
      border-radius: 14px;

      // @include background-gradient-1();
      // animation: shine-lines $animation-duration infinite linear;
      animation: background-opacity-1 $animation-duration infinite linear;
    }

    .franchisee-name {
      width: 78px;
      height: 28px; 
      margin-top: 23px;
      border-radius: 14px;

      //  background-color: #999;
      // @include background-gradient-1();
      // animation: shine-lines $animation-duration infinite linear;
      animation: background-opacity-1 $animation-duration infinite linear;
    }
    .product-name {
      width: 133px;
      height: 28px;
      margin-top: 6px;
      border-radius: 14px;

      // @include background-gradient-1();
      // animation: shine-lines $animation-duration infinite linear;
      animation: background-opacity-1 $animation-duration infinite linear;
    }
    .price-box {
      text-align: right;

      .price {
        display: inline-block;
        width: 187px;
        height: 40px;
        margin-top: 6px;
        border-radius: 20px;
  
        // @include background-gradient-1();
        // animation: shine-lines $animation-duration infinite linear;
        animation: background-opacity-1 $animation-duration infinite linear;
      }
    }
  }

  .body {
    padding: 30px 20px;

    .container {
      @include basic-display;
    }

    .text {
      padding: 0 10px;

      .body-title {
        width: 144px;
        height: 34px;
        border-radius: 17px;

        // @include background-gradient-2();
        animation: background-opacity-2 $animation-duration infinite linear;
      }

      .sub-title-full {
        width: 100%;
        height: 20px;
        margin-top: 5px;

        // @include background-gradient-2();
        animation: background-opacity-2 $animation-duration infinite linear;
      }
      .sub-title-article {
        width: 226px;
        height: 20px;

        // @include background-gradient-2();
        animation: background-opacity-2 $animation-duration infinite linear;
      }
    }

    .selector-list {
      margin-top: 20px;

      .selector-item {
        position: relative;
        width: 100%;
        height: 60px;

        border-radius: 18px;

        &:not(:first-of-type) {
          margin-top: 6px;
        }

        // @include background-gradient-2();
        animation: background-opacity-2 $animation-duration infinite linear;

        .check-item {
          display: inline-block;
          position: absolute;
          top: 20px;
          right: 21px;
          width: 20px;
          height: 20px;
          border-radius: 10px;

          background-color: #f2f2f2;
        }
      }
    }

    .input-box {
      margin-top: 20px;
      padding: 16px 20px 26px;

      border-radius: 18px;
      background-color: #d8d8d8;

      .input-row {

        .row-title {
          width: 78px;
          height: 28px;
          border-radius: 14px;
          background-color: #f2f2f2;

          animation: background-opacity-1 $animation-duration infinite linear;

        }

        .row-content {
          width: 100%;
          height: 28px;
          margin-top: 12px;
          border-radius: 14px;
          background-color: #f2f2f2;

          animation: background-opacity-1 $animation-duration infinite linear;
        }

        &:not(:first-of-type) {
          margin-top: 30px;
        }
      }

    }
  }

  .footer {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;

    .footer-button {
      width: 100%;
      height: 60px;

      // @include background-gradient-2();
      animation: background-opacity-2 $animation-duration infinite linear;
    }
  }
}

@keyframes shine-lines {
  0% {
    background-position: -100px center;
  }
  40%, 100% {
    background-position: 320px center;
  }
}
@keyframes shine-body {
  0% {
    background-position: -100px center;
  }
  40%, 100% {
    background-position: 600px center;
  }
}

@keyframes background-opacity-1 {
  0% {
    background-color: #f2f2f2;
  }
  50% {
    background-color: #f2f2f2;
    opacity: .2;
  }
  100% {
    background-color: #f2f2f2;
  }
}

@keyframes background-opacity-2 {
  0% {
    background-color: #d8d8d8;
  }
  50% {
    background-color: #d8d8d8;
    opacity: .2;
  }
  100% {
    background-color: #d8d8d8;
  }
}
</style>
